import React from 'react';
import { Box, Stack } from '@mui/material';
import { CategoryOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import {
  AssetNameEdit,
  AssetTagEdit,
  AssetCategoryEdit,
  ManufacturerEdit,
  ModelEdit,
  SerialNumberEdit,
  DescriptionEdit,
} from '../fields';

/**
 * IdentificationSection - Asset identification fields
 * Contains name, tag, category, manufacturer, model, serial number, and description
 */
export const IdentificationSection: React.FC = () => {
  return (
    <Box>
      <SectionHeader
        icon={<CategoryOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Identification"
      />
      <SectionPaper>
        <Stack spacing={2}>
          <Stack direction="row" gap={2}>
            <AssetNameEdit />
            <AssetTagEdit />
            <AssetCategoryEdit />
          </Stack>
          <Stack direction="row" gap={2}>
            <ManufacturerEdit />
            <ModelEdit />
            <SerialNumberEdit />
          </Stack>
          <DescriptionEdit />
        </Stack>
      </SectionPaper>
    </Box>
  );
};

export default IdentificationSection;
